import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './DashboardCardLayout.module.scss';

function DashboardCardLayout(props) {
  const { title, isDualLayout, children, leftContent, icon, isCustom, cardSize, extraComponent, clickAction } = props;

  const navigate = useNavigate();

  const renderDualLayout = () => {
    return (
      <>
        {isCustom ? (
          <div className={styles.flexColumn}>
            {leftContent}
            <h4 className={styles.title}>{title}</h4>
          </div>
        ) : (
          <div className={styles.flexColumn}>
            <img width="85px" src={icon} alt="icon" />
            <h4 className={styles.title}>{title}</h4>
          </div>
        )}
        <span className={styles.divider} />
        <div className={styles.flexColumn}>{children}</div>
      </>
    );
  };

  const renderSingleLayout = () => {
    return <div className={styles.singleFlexColumn}>{children}</div>;
  };

  const adaptiveCardLayout = (size) => {
    const layout = {
      'card-sm': 'innerContainer',
      'card-md': 'mediumContainer',
      'card-lg': 'largeContainer',
      'card-notification': 'notificationContainer'
    };
    return layout[size] ? layout[size] : null;
  };

  return (
    <div
      data-testid="wrapper"
      role="presentation"
      onClick={() => navigate(clickAction || '')}
      className={styles.wrapper}
    >
      <div className={clickAction ? styles.clickableCard : styles.cardContainer}>
        <h6>{title}</h6>
        <div className={adaptiveCardLayout(cardSize) ? styles[adaptiveCardLayout(cardSize)] : styles.innerContainer}>
          {isDualLayout ? renderDualLayout() : renderSingleLayout()}
        </div>
        {extraComponent && <div className={styles.extraComponent}>{extraComponent}</div>}
      </div>
    </div>
  );
}

export default DashboardCardLayout;
